<div class="header" *ngIf="false">

  <div class="header-last-synced" style="width: 20%">
    <>
  </div>

  <h1>City-Flow Management Console</h1>

  <div style="width: 20%; display: flex; justify-content: end">
    <button
      id="login"
      *ngIf="!userLoggedIn()"
      (click)="onLogin()">
      Login
    </button>
  </div>

</div>

<div *ngIf="loading" class="loading-indicator">
  <p-progressSpinner></p-progressSpinner>
</div>

<div *ngIf="!loading">

  <!-- Content Section -->
  <div class="container">
    <h2>Gerät initialisieren</h2>
    <div class="core-edit-max-width">
      <core-input-dropdown
        id="softwareType"
        label="Software Typ"
        [options]="softwareTypeOptions"
        [(ngModel)]="selectedSoftwareType">
      </core-input-dropdown>

      <core-input-dropdown
        id="moduleType"
        label="Modul Typ"
        [options]="moduleTypeOptions"
        [showClearButton]="true"
        [(ngModel)]="selectedModuleTypeCode">
      </core-input-dropdown>

      <core-input-dropdown
        id="chipType"
        label="Chip Typ"
        [options]="chipTypeOptions"
        [showClearButton]="true"
        [(ngModel)]="selectedChipTypeCode">
      </core-input-dropdown>

      <core-input-dropdown
        id="displayType"
        label="Display Typ"
        [options]="displayTypeOptions"
        [showClearButton]="true"
        [(ngModel)]="selectedDisplayTypeCode">
      </core-input-dropdown>

      <core-button-submit (click)="prepareInstall()" text="Manifest laden" [width]="'48%'"></core-button-submit>

      <div style="margin-top: 12px" *ngIf="manifestObjectUrl">
        <esp-web-install-button [attr.manifest]="manifestObjectUrl"></esp-web-install-button>
      </div>
    </div>
  </div>

</div>
